import { useEffect, useState } from "react";
import { Userprofile } from "../Entities/user-profile.entity";
import ProfileMatcherService from "../Services/profile.matcher.service";
import { useAuth } from "../Context/AuthContext/AuthContext";

export const useUserProfiles = () => {
  const { isUserLoggedIn } = useAuth();
  const profileMatcherService = new ProfileMatcherService();

  const [userProfiles, setUserProfiles] = useState<Userprofile[]>([]);

  const fetchUserProfiles = async () => {
    try {
      const profiles = await profileMatcherService.getAllUploadedProfiles();
      setUserProfiles(profiles);
    } catch (error: any) {
      console.error("Error fetching user profiles:", error);
      setUserProfiles([]);
    }
  };

  useEffect(() => {
    if (isUserLoggedIn) {
      fetchUserProfiles();
    }
  }, [isUserLoggedIn]);

  return {
    userProfiles,
  };
};
